import { create } from 'zustand';

interface defState {
  result: any;
  init: any;
  bindData: any;
}

/**
  데이터 상태관리
**/
export const setDeDataStore = create<defState>(set => ({
  result: { data: {} },
  init: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, data },
    })),
  bindData: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
}));
